module.exports = __webpack_public_path__ + "img/next.1eb989bf.svg";